import { useMemo } from "react";
import { useAppSelector } from "@app-redux/store";
import { filtersSelector } from "@app-redux/selectors";
import { useCategories } from "./useCategories";
import { useProfileList } from "./useProfileList";
import { getCategoryFilters } from "@utils/index";

export function useProfileListWithFilters() {
  const filters = useAppSelector(filtersSelector);
  const { data: categoryData, map, isCategoryMap } = useCategories();

  const profileListFilters = useMemo(() => {
    if (!isCategoryMap) return null;
    const { categories_values, page, ...rest } = filters;
    const categoryFilters = getCategoryFilters(map, categories_values, categoryData);
    return { ...rest, ...categoryFilters };
  }, [filters, isCategoryMap, map, categoryData]);

  return useProfileList(profileListFilters ?? {}, !!profileListFilters);
}
